module.exports = __webpack_public_path__ + "img/龙胆.b676dd7b.jpg";